export default {
  hasBoats: 'Båtuthyrning',
  fishSpecies: 'Fiskarter',
  fishingMethods: 'Fiskemetoder',
  amenities: 'Bekvämligheter',
};
